<script setup lang="ts">
import type {HTMLAttributes} from 'vue'
import {ToastTitle} from 'reka-ui'
import {cn} from '@/lib/utils'

const props = defineProps<{class?: HTMLAttributes['class']}>()
</script>

<template>
  <ToastTitle :class="cn('text-sm font-semibold', props.class)"><slot /></ToastTitle>
</template>
